/* eslint-disable no-unused-vars */
import { IOptionAnyValue } from 'bricks/types';
import { ProFormaModelIds } from 'constants/proForma';

export enum ColumnKeys {
    NAME = 'name',
    ANNUAL_GROWTH = 'annualGrowth',
    PERCENT_OF_EGR = 'percentOfEffectiveGrossRevenue',
    COST_PER_UNIT_PER_YEAR = 'costPerUnitPerYear',
    TOTAL_AMOUNT_PER_YEAR = 'totalAmountPerYear',
}

export const COLUMN_KEYS_BY_MODEL_ID: Record<string, ColumnKeys[]> = {
    [ProFormaModelIds.APARTMENT]: [
        ColumnKeys.NAME,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.COST_PER_UNIT_PER_YEAR,
        ColumnKeys.TOTAL_AMOUNT_PER_YEAR,
    ],
    // additional mappings here for other models
};

export enum CAPITAL_RESERVES_OPTION_VALUES {
    OPEX = 'opex',
    CAPEX = 'capex',
}
export const CAPITAL_RESERVES_OPTIONS: IOptionAnyValue[] = [
    { value: CAPITAL_RESERVES_OPTION_VALUES.OPEX, label: 'Operating expenses' },
    { value: CAPITAL_RESERVES_OPTION_VALUES.CAPEX, label: 'Capital expenditures' },
];
